//noScroll
class Accordion {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.js-accordion li:first .ttl').addClass('is-open');
    $('.js-open').click(function(){
      var index = $(this).index();
      $(this).toggleClass('is-open');
      $(this).next().slideToggle(300);
      $('.js-open').not($(this)).next().slideUp();
      $('.js-open').not($(this)).removeClass('is-open');
      // $('.map-img figure').eq(index).addClass('active');
    });
  }
}
